// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-product-modal-modal_card-B2pcU {
  width: 340px;
  height: auto;
  max-height: 680px;
}

.add-product-modal-modal_content-MRb9r {
  overflow: scroll;
  padding: 0px 10px 4px 20px;
}

.add-product-modal-textField_container-wmgzZ,
.add-product-modal-textArea_container-_0gtK,
.add-product-modal-select_container-HE2zG,
.add-product-modal-autocomplete_container-s_q_v,
.add-product-modal-priceField_container-JtgUp,
.add-product-modal-imageField-zPYP0 {
  width: 100%;
  margin-top: 20px;
}

.add-product-modal-select_popup-J1h7D {
  max-height: 400px;
}

.add-product-modal-textArea_input-OfpoT {
  height: 60px;
}

.add-product-modal-autocomplete_popup-jvWkN {
  max-height: 280px;
}

.add-product-modal-priceField_iconContainer-LDOp_ {
  padding-right: 8px;
}

.add-product-modal-addPriceIcon-XGzgm {
  width: fit-content;
  height: fit-content;
  font-size: 24px;
  color: var(--color-neutral-500);
  padding: 4px;
}

.add-product-modal-addPriceIcon-XGzgm:hover {
  color: var(--color-neutral-600);
}

.add-product-modal-addPriceIcon-XGzgm:active {
  color: var(--color-neutral-800);
}

.add-product-modal-prices-hjPZ5 {
  display: flex;
  flex-flow: row wrap;
  gap: 6px;
  margin-top: 12px;
}

.add-product-modal-priceItem-uuLTV {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0px;
  cursor: pointer;
  background-color: var(--color-green-100);
  border-radius: 20px;
  transition: gap 200ms ease, padding-right 200ms ease;
  padding: 6px 12px;
}

.add-product-modal-priceItem-uuLTV:hover {
  gap: 8px;
  padding-right: 10px;
}

.add-product-modal-priceValue-YQA9s {
  color: var(--color-green-950);
}

.add-product-modal-priceDeleteIcon-fmCzL {
  width: 0px;
  height: fit-content;
  font-size: 18px;
  color: var(--color-green-900);
  opacity: 0;
  transition: width 200ms ease, visibility 200ms 200ms ease;
}

.add-product-modal-priceItem-uuLTV:hover .add-product-modal-priceDeleteIcon-fmCzL {
  width: 18px;
  opacity: 0.8;
}

.add-product-modal-priceItem-uuLTV:hover .add-product-modal-priceDeleteIcon-fmCzL:hover {
  opacity: 1;
}

.add-product-modal-priceDeleteIcon-fmCzL:active {
  opacity: 1;
  color: var(--color-black);
}
`, "",{"version":3,"sources":["webpack://./src/pages/products/add-product-modal/add-product-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;;;;EAME,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,UAAU;EACV,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n  max-height: 680px;\n}\n\n.modal_content {\n  overflow: scroll;\n  padding: 0px 10px 4px 20px;\n}\n\n.textField_container,\n.textArea_container,\n.select_container,\n.autocomplete_container,\n.priceField_container,\n.imageField {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.select_popup {\n  max-height: 400px;\n}\n\n.textArea_input {\n  height: 60px;\n}\n\n.autocomplete_popup {\n  max-height: 280px;\n}\n\n.priceField_iconContainer {\n  padding-right: 8px;\n}\n\n.addPriceIcon {\n  width: fit-content;\n  height: fit-content;\n  font-size: 24px;\n  color: var(--color-neutral-500);\n  padding: 4px;\n}\n\n.addPriceIcon:hover {\n  color: var(--color-neutral-600);\n}\n\n.addPriceIcon:active {\n  color: var(--color-neutral-800);\n}\n\n.prices {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.priceItem {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0px;\n  cursor: pointer;\n  background-color: var(--color-green-100);\n  border-radius: 20px;\n  transition: gap 200ms ease, padding-right 200ms ease;\n  padding: 6px 12px;\n}\n\n.priceItem:hover {\n  gap: 8px;\n  padding-right: 10px;\n}\n\n.priceValue {\n  color: var(--color-green-950);\n}\n\n.priceDeleteIcon {\n  width: 0px;\n  height: fit-content;\n  font-size: 18px;\n  color: var(--color-green-900);\n  opacity: 0;\n  transition: width 200ms ease, visibility 200ms 200ms ease;\n}\n\n.priceItem:hover .priceDeleteIcon {\n  width: 18px;\n  opacity: 0.8;\n}\n\n.priceItem:hover .priceDeleteIcon:hover {\n  opacity: 1;\n}\n\n.priceDeleteIcon:active {\n  opacity: 1;\n  color: var(--color-black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `add-product-modal-modal_card-B2pcU`,
	"modal_content": `add-product-modal-modal_content-MRb9r`,
	"textField_container": `add-product-modal-textField_container-wmgzZ`,
	"textArea_container": `add-product-modal-textArea_container-_0gtK`,
	"select_container": `add-product-modal-select_container-HE2zG`,
	"autocomplete_container": `add-product-modal-autocomplete_container-s_q_v`,
	"priceField_container": `add-product-modal-priceField_container-JtgUp`,
	"imageField": `add-product-modal-imageField-zPYP0`,
	"select_popup": `add-product-modal-select_popup-J1h7D`,
	"textArea_input": `add-product-modal-textArea_input-OfpoT`,
	"autocomplete_popup": `add-product-modal-autocomplete_popup-jvWkN`,
	"priceField_iconContainer": `add-product-modal-priceField_iconContainer-LDOp_`,
	"addPriceIcon": `add-product-modal-addPriceIcon-XGzgm`,
	"prices": `add-product-modal-prices-hjPZ5`,
	"priceItem": `add-product-modal-priceItem-uuLTV`,
	"priceValue": `add-product-modal-priceValue-YQA9s`,
	"priceDeleteIcon": `add-product-modal-priceDeleteIcon-fmCzL`
};
export default ___CSS_LOADER_EXPORT___;
